module.exports = __webpack_public_path__ + "static/img/cont59 (7).0fb077a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont59 (7).jpg
// module id = Pua2
// module chunks = 0